// extracted by mini-css-extract-plugin
module.exports = {"svg-base":"RkJDe","svg":"M3ZvM","svg--dark":"iOoKR"};